
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { getAccountUsernameFromPath, RootState, GetHomeParams } from '@share/utils';
import { resetCarsState } from '@store/slices';
import { ResetCarsFull } from '@share/store/slices';
import { Routes } from '@share/constants';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

export function CarsGoHome() {

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account } = loginStore;

  const history = useHistory();

  const dispatch = useDispatch();

  const accountName = getAccountUsernameFromPath(history);
  const isDisableHomes = account?.isDisableHomes;

  const homeParams = GetHomeParams(account);
      
  if (isDisableHomes) {
    return null;
  }

  return (
    <div className="back-home" onClick={() => {
      dispatch(ResetCarsFull());
      dispatch(resetCarsState());
      
      history.push(`/${accountName}${Routes.CarsSearch}${homeParams}`);
    }}>
      <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5px' }} /> <FormattedMessage id="back.home" />
    </div>
  );
}
